import React from "react";

export function RibbonTitle({ children, variant = "", className = "" }) {
  return (
    <div className={`flex justify-center -mt-10 mb-4 ${className}`}>
      <span className={`ribbon ${variant} text-sm sm:text-base`}>{children}</span>
    </div>
  );
}

export default function MagicalCard({ title, variant = "", children, className = "", hover = true, testId, headerExtra }) {
  return (
    <section data-testid={testId} className={`magic-panel ${hover ? "magic-panel-hover" : ""} relative p-5 pt-9 ${className}`}>
      {title ? (
        <div className="flex justify-center -mt-[3.4rem] mb-4 relative z-10">
          <span className={`ribbon ${variant} text-sm sm:text-base`}>{title}</span>
        </div>
      ) : null}
      {headerExtra}
      {children}
    </section>
  );
}
